import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`../locales/${language}/${namespace}.json`),
    ),
  )
  .init({
    lng: "ar",
    fallbackLng: "ar",
    ns: ["payments", "common", "order-tracking", "status"],
    defaultNS: "common",
    react: {
      useSuspense: true,
    },
  });
